import TableMobile from './TableMobile';

export default TableMobile;